// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SlIdM35J2L4Tpo4mwswM,
.e_Z3dgZvg01_KMmxiYNA {
  z-index: 101;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dnrRRaWmNA6pSGxpP3SZ {
  width: 43.75rem;
  height: 16.25rem;
  padding: 0 3.125rem;
  border-radius: 0.3125rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/ErrorModal/ErrorModal.module.css"],"names":[],"mappings":"AAAA;;EAEE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAY;EACZ,gBAAa;EACb,mBAAe;EACf,wBAAkB;AACpB","sourcesContent":[".errorModalOverlay,\n.errorModalContent {\n  z-index: 101;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.modalContentWrapper {\n  width: 700px;\n  height: 260px;\n  padding: 0 50px;\n  border-radius: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorModalOverlay": `SlIdM35J2L4Tpo4mwswM`,
	"errorModalContent": `e_Z3dgZvg01_KMmxiYNA`,
	"modalContentWrapper": `dnrRRaWmNA6pSGxpP3SZ`
};
export default ___CSS_LOADER_EXPORT___;
